import { render, staticRenderFns } from "./queryTenderSortNum.vue?vue&type=template&id=14f84b4b&scoped=true&"
import script from "./queryTenderSortNum.vue?vue&type=script&lang=js&"
export * from "./queryTenderSortNum.vue?vue&type=script&lang=js&"
import style0 from "./queryTenderSortNum.vue?vue&type=style&index=0&id=14f84b4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f84b4b",
  null
  
)

export default component.exports